import React from "react";
import LegalPage from "./LegalPage";
import { BRAND } from "@/constants/content";

const RefundPolicy = () => (
  <LegalPage
    title="Refund Policy"
    description="How refunds work for the BoostF eCommerce Launch Marathon."
  >
    <p>
      The ₹{BRAND.price} registration fee is a symbolic commitment fee designed to keep the
      community focused and serious. Because the value of the marathon lies primarily in
      the private community, live sessions and downloadable resources, our refund policy
      is intentionally simple and transparent.
    </p>

    <h2>1. Cancellation window</h2>
    <p>
      You may request a refund within 24 hours of registration, as long as you have not
      accessed the private WhatsApp Community or downloaded any marathon resources.
    </p>

    <h2>2. After the community access</h2>
    <p>
      Once you have joined the private community or accessed any resources, the
      registration fee becomes non-refundable.
    </p>

    <h2>3. Failed payments</h2>
    <p>
      If your payment is charged but you did not receive confirmation, please email us at
      {" "}{BRAND.supportEmail} with your payment ID and we will resolve it within 3–5 business
      days.
    </p>

    <h2>4. How to request a refund</h2>
    <p>
      Please write to {BRAND.supportEmail} with the subject line &quot;Refund Request&quot; along
      with the email you registered with and your payment ID. Approved refunds are
      typically processed within 7–10 business days via the original payment method.
    </p>
  </LegalPage>
);

export default RefundPolicy;
